import { useContext } from "react";
import { Button, Col, Row, Table, Tag } from "antd";
import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    CloseCircleOutlined,
    ReloadOutlined,
    UnlockOutlined,
} from "@ant-design/icons";

import useRecoverRequests from "./useRecoverRequests";
import PageHeader from "../../components/PageHeader";
import ActiveFiltersBar from "../../components/ActiveFiltersBar";
import TableCard from "../../components/TableCard";
import TableDicaHint from "../../components/TableDicaHint";
import TablePagination from "../../components/TablePagination";
import KpiCard from "../../components/KpiCard";
import { ThemeContext } from "../../contexts/ThemeContext";
import { poeValorComPontosEmMil } from "../../utils/Conversores";

export default function RecoverRequests() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    const {
        isLoading,
        columns,
        tableData,
        stats,
        pagination,
        activeFilterItems,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        handleClickViewRequest,
        reloadData,
    } = useRecoverRequests();

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <PageHeader
                icon={<UnlockOutlined />}
                iconBg="linear-gradient(135deg, #fa8c16 0%, #fa541c 100%)"
                title="Recuperação de Acesso"
                tag={<Tag color="orange">{poeValorComPontosEmMil(stats.total)} solicitações</Tag>}
                subtitle="Gerencie, analise e valide as solicitações de alteração de número de celular dos cidadãos"
                actions={
                    <Button
                        icon={<ReloadOutlined />}
                        onClick={reloadData}
                        loading={isLoading}
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 6,
                            fontWeight: 500,
                            height: 38,
                            borderRadius: 8,
                        }}
                    >
                        Atualizar
                    </Button>
                }
            />

            {/* KPI Cards */}
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<UnlockOutlined />}
                        title="Total de Solicitações"
                        value={poeValorComPontosEmMil(stats.total)}
                        accentColor="#1677ff"
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<ClockCircleOutlined />}
                        title="Em Análise (Pendentes)"
                        value={poeValorComPontosEmMil(stats.pendentes)}
                        accentColor="#faad14"
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<CheckCircleOutlined />}
                        title="Solicitações Aprovadas"
                        value={poeValorComPontosEmMil(stats.aprovados)}
                        accentColor="#52c41a"
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<CloseCircleOutlined />}
                        title="Solicitações Recusadas"
                        value={poeValorComPontosEmMil(stats.recusados)}
                        accentColor="#ff4d4f"
                    />
                </Col>
            </Row>

            {/* Active Filters Bar */}
            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Dê um clique em qualquer linha para abrir a análise da solicitação, ou utilize o botão de ação à direita." />

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={handlePaginationChange}
                itemName="solicitações"
                pageSizeOptions={["10", "25", "50", "100"]}
            />

            {/* Table Container */}
            <TableCard>
                <Table
                    rowKey="id"
                    size="middle"
                    className={`modern-data-table ${isDark ? "modern-data-table-dark" : ""}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    onChange={handleTableChange}
                    scroll={{ x: 850 }}
                    onRow={(record) => ({
                        onClick: () => {
                            handleClickViewRequest(record);
                        },
                        style: {
                            cursor: "pointer",
                        },
                    })}
                    locale={{
                        emptyText: "Nenhuma solicitação de recuperação de acesso encontrada.",
                    }}
                />
            </TableCard>

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={handlePaginationChange}
                itemName="solicitações"
                pageSizeOptions={["10", "25", "50", "100"]}
            />
        </div>
    );
}
